import React, { createContext, useContext, useEffect, useState } from 'react';

interface WebsiteControls {
  contactFormControls: ContactFormControls;
}

interface ContactFormControls {
  closeFormUntil: string;
  formClosedHeader: string;
  formClosedMessage: string;
}

interface WebsiteControlsContextValue {
  websiteControls: WebsiteControls | null;
  loading: boolean;
  error: string | null;
}

const url = 'https://script.google.com/macros/s/AKfycbxs0e4D4mZhGQNy08APyNWVC2pEZIQ46J1VLk4fpxLgF4Nvy6eqGAwKXKXReRru4fh32A/exec';

const WebsiteControlsContext = createContext<WebsiteControlsContextValue | undefined>(undefined);

export function WebsiteControlsProvider({ children }: { children: React.ReactNode }) {
  const [websiteControls, setWebsiteControls] = useState<WebsiteControls | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    const fetchData = async () => {
      try {
        const response = await fetch(url, { signal });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result: WebsiteControls = await response.json();
        setWebsiteControls(result);
        setLoading(false);
      } catch (err) {
        if (err instanceof Error && err.name === 'AbortError') {
          // request was cancelled — don't touch state
          return;
        }
        setError(err instanceof Error ? err.message : 'An unexpected error occurred');
        setLoading(false);
      }
    };

    fetchData();

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <WebsiteControlsContext.Provider value={{ websiteControls, loading, error }}>
      {children}
    </WebsiteControlsContext.Provider>
  );
}

export function useWebsiteControls(): WebsiteControlsContextValue {
  const context = useContext(WebsiteControlsContext);
  if (context === undefined) {
    throw new Error('useWebsiteControls must be used within a WebsiteControlsProvider');
  }
  return context;
}